import { OsType } from '../common/enums/Os';
import { IVersion } from '../common/interfaces/Version.interface';

/** There is one version record per OS, so a version can be added while iOS or Android has none. */
export const canAddVersion = (versions: Pick<IVersion, 'osType'>[]) =>
  !versions.some((v) => v.osType === OsType.Ios) ||
  !versions.some((v) => v.osType === OsType.Android);
